import R from 'ramda'

const isNotNumber = R.complement(R.is(Number))

const lessThan5 = R.gt(5)

const greaterThan55 = R.lt(55)

const isNotMultipleOf5 = x => x % 5 !== 0

const getCurrentDateTime = () => new Date().valueOf()

const jsonParseWithMangoAtchar = R.curryN(1, JSON.parse)

const propAsJson = propertyName =>
  R.pipe(R.prop('data'), JSON.parse, R.prop(propertyName))

const stringifyBody = R.pipe(propAsJson('body'), JSON.stringify)

const hasBody = R.pipe(R.path(['data', 'body']), R.isNil)

const getIndentedJSONString = value => JSON.stringify(value, null, 2)

/**
 * @typedef {object} GoogleSheetAppendAction Google Sheet Append Action
 * @property {"GOOGLE_SHEET_APPEND"} type the action type
 * @property {string} spreadsheetId the Google Spreadsheet Id
 * @property {number} sheetId the Google Sheet Id (worksheet/tab)
 * @property {string} row a comma separated list of values to add to the sheet (including merge fields)
 */
function buildGoogleSheetUrl (action) {
  const isNeitherEmptyNorNil = R.complement(R.and(R.isEmpty, R.isNil))

  const hasAllValidProperties = R.pipe(
    R.props(['spreadsheetId', 'sheetId']),
    R.all(isNeitherEmptyNorNil)
  )

  if (!hasAllValidProperties(action)) {
    return ''
  }

  const spreadsheetId = R.prop('spreadsheetId', action)
  const sheetId = R.prop('sheetId', action)

  return `https://docs.google.com/spreadsheets/d/${spreadsheetId}/edit#gid=${sheetId}`
}

export {
  isNotNumber,
  lessThan5,
  greaterThan55,
  isNotMultipleOf5,
  getCurrentDateTime,
  buildGoogleSheetUrl,
  jsonParseWithMangoAtchar,
  propAsJson,
  stringifyBody,
  hasBody,
  getIndentedJSONString
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/common-functions.js